/* ============================================================
   TheWootz — Theme JS
   ============================================================ */

(function() {
  'use strict';

  // ========== HELPERS ==========
  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  };

  const showToast = (message) => {
    const existing = document.querySelector('.toast');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' + message;
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('show'));
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 300);
    }, 2600);
  };

  // ========== DRAWER OPEN/CLOSE ==========
  const getDrawer = () => document.querySelector('[data-cart-drawer]');
  const getBackdrop = () => document.querySelector('[data-cart-backdrop]');
  const getCartBody = () => document.querySelector('[data-cart-body]');
  const getCartFooter = () => document.querySelector('[data-cart-footer]');

  const openDrawer = () => {
    const drawer = getDrawer();
    const backdrop = getBackdrop();
    if (!drawer || !backdrop) return;
    drawer.classList.add('open');
    backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    const drawer = getDrawer();
    const backdrop = getBackdrop();
    if (!drawer || !backdrop) return;
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    document.body.style.overflow = '';
  };

  // ========== CART FETCH / RENDER ==========
  const fetchCart = async () => {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  };

  // ========== UPSELL ==========
  // Helper: fetch product IDs from a collection (cached per trigger collection)
  const _collectionCache = new Map();
  const getCollectionProductIds = async (handle) => {
    if (!handle) return null;
    if (_collectionCache.has(handle)) return _collectionCache.get(handle);
    try {
      const res = await fetch(`/collections/${handle}/products.json?limit=250`);
      if (!res.ok) { _collectionCache.set(handle, null); return null; }
      const data = await res.json();
      const ids = new Set((data.products || []).map(p => p.id));
      _collectionCache.set(handle, ids);
      return ids;
    } catch (err) {
      _collectionCache.set(handle, null);
      return null;
    }
  };

  // Count items from a specific collection in the cart
  const countCartItemsFromCollection = async (cart, triggerHandle) => {
    if (!triggerHandle) return cart.items.reduce((sum, i) => sum + i.quantity, 0);
    const ids = await getCollectionProductIds(triggerHandle);
    if (!ids) return 0;
    return cart.items
      .filter(item => ids.has(item.product_id))
      .reduce((sum, i) => sum + i.quantity, 0);
  };

  // Build HTML for one upsell card
  const upsellCardHTML = (data) => `
    <div class="cart-upsell-card">
      ${data.image ? `<img src="${data.image}" alt="${data.title}" class="cart-upsell-img" />` : ''}
      <div class="cart-upsell-body">
        <div class="cart-upsell-subtitle">${data.subtitle}</div>
        <div class="cart-upsell-title">${data.title}</div>
        <div class="cart-upsell-price">${data.price}</div>
      </div>
      <button type="button" class="cart-upsell-add" data-upsell-add data-variant-id="${data.variantId}">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        Toevoegen
      </button>
    </div>
  `;

  // Extract upsell data from drawer attributes
  const getUpsellData = (drawer, n) => {
    const id = drawer.getAttribute(`data-up${n}-id`);
    if (!id) return null;
    return {
      variantId: id,
      productId: drawer.getAttribute(`data-up${n}-product-id`),
      title: drawer.getAttribute(`data-up${n}-title`) || '',
      subtitle: drawer.getAttribute(`data-up${n}-subtitle`) || '',
      price: drawer.getAttribute(`data-up${n}-price`) || '',
      image: drawer.getAttribute(`data-up${n}-image`) || '',
    };
  };

  const renderUpsell = async (cart) => {
    const slot = document.querySelector('[data-cart-upsell]');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!slot || !drawer) return;

    const triggerCollection = drawer.getAttribute('data-upsell-trigger-collection') || '';
    const threshold = parseInt(drawer.getAttribute('data-upsell-multi-threshold') || '2', 10);

    const up1 = getUpsellData(drawer, 1); // single plank → 250 ml
    const up2 = getUpsellData(drawer, 2); // multi planken → 500 ml
    const up3 = getUpsellData(drawer, 3); // bundle / pakket

    // If cart has no trigger-collection products (no planken), show nothing
    const plankenCount = await countCartItemsFromCollection(cart, triggerCollection);
    if (plankenCount === 0) {
      slot.hidden = true;
      slot.innerHTML = '';
      return;
    }

    const cartProductIds = new Set(cart.items.map(i => String(i.product_id)));
    const isInCart = (productId) => productId && cartProductIds.has(String(productId));

    // Decide which oil-upsell to show (1 plank → up1, 2+ → up2)
    let oilUpsell = null;
    if (plankenCount >= threshold && up2 && !isInCart(up2.productId)) {
      oilUpsell = up2;
    } else if (up1 && !isInCart(up1.productId)) {
      oilUpsell = up1;
    } else if (up2 && !isInCart(up2.productId)) {
      // Fallback: if only up2 is configured or up1 is already in cart
      oilUpsell = up2;
    }

    // Bundle upsell (up3) shows as second card, if configured and not already in cart
    const bundleUpsell = (up3 && !isInCart(up3.productId)) ? up3 : null;

    // If neither is available, hide slot
    if (!oilUpsell && !bundleUpsell) {
      slot.hidden = true;
      slot.innerHTML = '';
      return;
    }

    let html = '';
    if (oilUpsell) html += upsellCardHTML(oilUpsell);
    if (bundleUpsell) html += upsellCardHTML(bundleUpsell);

    slot.hidden = false;
    slot.innerHTML = html;
  };

  const renderCart = async () => {
    const body = getCartBody();
    const footer = getCartFooter();
    if (!body || !footer) return;

    body.classList.add('cart-loading');
    try {
      const cart = await fetchCart();
      updateCartCount(cart.item_count);

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>Je mandje is nog leeg.</p><a href="/collections/all" class="btn btn-primary" data-cart-close>Bekijk de collectie</a></div>';
        footer.innerHTML = '';
        return;
      }

      let html = '';
      cart.items.forEach(item => {
        const imgSrc = item.image || item.featured_image?.url || '';
        const variant = (item.variant_title && item.variant_title !== 'Default Title') ? `<div class="cart-item-variant">${item.variant_title}</div>` : '';
        html += `
          <div class="cart-item" data-line-key="${item.key}">
            <a href="${item.url}" class="cart-item-img">${imgSrc ? `<img src="${imgSrc}" alt="${item.product_title}" />` : ''}</a>
            <div class="cart-item-body">
              <a href="${item.url}" class="cart-item-title">${item.product_title}</a>
              ${variant}
              <div class="cart-item-row">
                <div class="qty-ctrl">
                  <button type="button" data-qty-decrement aria-label="Minder">−</button>
                  <span>${item.quantity}</span>
                  <button type="button" data-qty-increment aria-label="Meer">+</button>
                </div>
                <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
              </div>
              <button type="button" class="cart-item-remove" data-qty-remove>Verwijderen</button>
            </div>
          </div>
        `;
      });
      body.innerHTML = html;

      // ===== UPSELL in cart drawer =====
      await renderUpsell(cart);

      footer.innerHTML = `
        <div class="cart-subtotal">
          <span class="cart-subtotal-label">Subtotaal</span>
          <span class="cart-subtotal-value">${formatMoney(cart.total_price)}</span>
        </div>
        <p class="cart-note">Verzend- en afhandelingskosten worden bij afrekenen berekend. Gratis verzending vanaf €75.</p>
        <a href="/checkout" class="cart-checkout">Afrekenen
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </a>
      `;
    } catch (err) {
      console.error('[TheWootz cart] render error', err);
      body.innerHTML = '<div class="cart-empty"><p>Er ging iets mis bij het laden.</p></div>';
    } finally {
      body.classList.remove('cart-loading');
    }
  };

  // ========== UPDATE CART QUANTITY ==========
  const updateQuantity = async (lineKey, newQty) => {
    const body = getCartBody();
    if (body) body.classList.add('cart-loading');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      });
      if (!res.ok) {
        const errText = await res.text();
        console.error('[TheWootz cart] change failed', res.status, errText);
        throw new Error('Cart change failed');
      }
      await renderCart();
    } catch (err) {
      console.error('[TheWootz cart] update error', err);
      if (body) body.classList.remove('cart-loading');
      showToast('Kon niet bijwerken, probeer opnieuw');
    }
  };

  // ========== DOCUMENT-LEVEL EVENT DELEGATION ==========

  // Open/close drawer + cart item actions + add-to-cart
  document.addEventListener('click', async (e) => {
    // OPEN DRAWER
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      renderCart();
      return;
    }

    // CLOSE DRAWER
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.target.matches && e.target.matches('[data-cart-backdrop]')) {
      closeDrawer();
      return;
    }

    // CART ITEM: REMOVE
    const removeBtn = e.target.closest('[data-qty-remove]');
    if (removeBtn) {
      e.preventDefault();
      const line = removeBtn.closest('[data-line-key]');
      if (!line) return;
      const key = line.getAttribute('data-line-key');
      updateQuantity(key, 0);
      return;
    }

    // CART ITEM: INCREMENT
    const incBtn = e.target.closest('[data-qty-increment]');
    if (incBtn) {
      e.preventDefault();
      const line = incBtn.closest('[data-line-key]');
      if (!line) return;
      const key = line.getAttribute('data-line-key');
      const qtySpan = line.querySelector('.qty-ctrl span');
      const currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
      updateQuantity(key, currentQty + 1);
      return;
    }

    // CART ITEM: DECREMENT
    const decBtn = e.target.closest('[data-qty-decrement]');
    if (decBtn) {
      e.preventDefault();
      const line = decBtn.closest('[data-line-key]');
      if (!line) return;
      const key = line.getAttribute('data-line-key');
      const qtySpan = line.querySelector('.qty-ctrl span');
      const currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
      const newQty = Math.max(0, currentQty - 1);
      updateQuantity(key, newQty);
      return;
    }

    // UPSELL ADD (cart drawer upsell button)
    const upsellBtn = e.target.closest('[data-upsell-add]');
    if (upsellBtn) {
      e.preventDefault();
      const variantId = upsellBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      upsellBtn.disabled = true;
      const originalHTML = upsellBtn.innerHTML;
      upsellBtn.innerHTML = 'Toevoegen…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('Upsell add failed');
        showToast('Onderhoudsolie toegevoegd');
        renderCart();
      } catch (err) {
        console.error('[TheWootz upsell] add error', err);
        showToast('Kon niet toevoegen, probeer opnieuw');
        upsellBtn.disabled = false;
        upsellBtn.innerHTML = originalHTML;
      }
      return;
    }

    // ADD TO CART
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      const variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      // Check if bundle checkboxes are checked (product-page upsell — multiple allowed)
      const bundleCheckboxes = document.querySelectorAll('[data-bundle-checkbox]:checked');
      const bundleVariantIds = Array.from(bundleCheckboxes)
        .map(cb => cb.getAttribute('data-variant-id'))
        .filter(id => id && id !== variantId);

      addBtn.disabled = true;
      const originalHTML = addBtn.innerHTML;
      addBtn.innerHTML = 'Toevoegen…';

      try {
        // Shopify supports adding multiple items in one request via /cart/add.js 'items' array
        const items = [{ id: variantId, quantity: 1 }];
        bundleVariantIds.forEach(bvId => {
          items.push({ id: bvId, quantity: 1 });
        });
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });
        if (!res.ok) {
          const errText = await res.text();
          console.error('[TheWootz cart] add failed', res.status, errText);
          throw new Error('Add failed');
        }
        const msg = bundleVariantIds.length > 0
          ? (bundleVariantIds.length === 1 ? 'Plank + extra toegevoegd' : `Plank + ${bundleVariantIds.length} extra's toegevoegd`)
          : 'Toegevoegd aan je mandje';
        showToast(msg);
        const cart = await fetchCart();
        updateCartCount(cart.item_count);
        // Reset bundle checkboxes
        bundleCheckboxes.forEach(cb => cb.checked = false);
        openDrawer();
        renderCart();
      } catch (err) {
        console.error('[TheWootz cart] add error', err);
        showToast('Kon niet toevoegen, probeer opnieuw');
      } finally {
        addBtn.disabled = false;
        addBtn.innerHTML = originalHTML;
      }
      return;
    }
  });

  // ESC closes drawer
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  // ========== CAROUSELS ==========
  const initCarousel = (id) => {
    const track = document.querySelector('[data-carousel-id="' + id + '"]');
    const prevBtn = document.querySelector('[data-carousel="' + id + '"][data-dir="prev"]');
    const nextBtn = document.querySelector('[data-carousel="' + id + '"][data-dir="next"]');
    const progress = document.querySelector('[data-progress="' + id + '"]');
    if (!track) return;

    const getStep = () => {
      const card = track.querySelector('.pcard');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 24;
      return card.offsetWidth + gap;
    };

    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 2;
      if (progress) {
        let pct;
        if (max <= 0) {
          // Content fits - no scrolling possible
          pct = 100;
        } else {
          // Fraction scrolled through the scrollable area, minimum 10% visible
          pct = 10 + (track.scrollLeft / max) * 90;
        }
        progress.style.width = Math.min(100, Math.max(10, pct)) + '%';
      }
    };

    // Update progress after smooth-scroll finishes (scroll event keeps firing during animation)
    let scrollDebounce;
    const scheduleUpdate = () => {
      update();
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(update, 350);
    };

    if (prevBtn) prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      scheduleUpdate();
    });
    if (nextBtn) nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
      scheduleUpdate();
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Initial update - run multiple times to catch late-loading images
    update();
    setTimeout(update, 100);
    setTimeout(update, 500);
    if (window.addEventListener) {
      window.addEventListener('load', update);
    }
  };

  document.querySelectorAll('[data-carousel-id]').forEach(el => initCarousel(el.getAttribute('data-carousel-id')));

  // ========== FAQ ACCORDION ==========
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement;
      const openItem = document.querySelector('.faq-item.open');
      if (openItem && openItem !== item) openItem.classList.remove('open');
      item.classList.toggle('open');
    });
  });

  // ========== PRODUCT PAGE VARIANTS + GALLERY ==========
  document.querySelectorAll('[data-variant]').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('[data-variant]').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const id = btn.getAttribute('data-variant');
      const priceEl = document.querySelector('[data-product-price]');
      const addBtn = document.querySelector('[data-add-to-cart]');
      const price = btn.getAttribute('data-price');
      const available = btn.getAttribute('data-available') === 'true';
      if (priceEl && price) priceEl.textContent = price;
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', id);
        addBtn.disabled = !available;
        addBtn.innerHTML = available
          ? 'In mandje <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>'
          : 'Uitverkocht';
      }
    });
  });

  document.querySelectorAll('[data-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-src');
      const main = document.querySelector('[data-main-image]');
      if (main && src) main.src = src;
      document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ========== INIT CART COUNT ==========
  fetchCart().then(cart => updateCartCount(cart.item_count)).catch((err) => {
    console.warn('[TheWootz cart] init count failed', err);
  });

})();
